/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesUiControl = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type WebApiModelsEnumerationTypesUiControl = typeof WebApiModelsEnumerationTypesUiControl[keyof typeof WebApiModelsEnumerationTypesUiControl];


export function WebApiModelsEnumerationTypesUiControlFromJSON(json: any): WebApiModelsEnumerationTypesUiControl {
    return WebApiModelsEnumerationTypesUiControlFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesUiControlFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesUiControl {
    return json as WebApiModelsEnumerationTypesUiControl;
}

export function WebApiModelsEnumerationTypesUiControlToJSON(value?: WebApiModelsEnumerationTypesUiControl | null): any {
    return value as any;
}

